import {
  CREATE_GATING_CONFIGURATION_REQUEST,
  UPDATE_GATING_CONFIGURATION_REQUEST, DELETE_GATING_CONFIGURATION_REQUEST, INVALIDATE_GATING_CONFIGURATIONS,
  DELETE_ASSET_MAPPINGS_GATING_REQUEST, DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED, DELETING_ASSET_MAPPINGS_GATING_FAILED,
  CREATE_GATING_CONFIGURATION_FOR_MAPPING_REQUEST, CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED, CREATING_GATING_CONFIGURATION_FOR_MAPPING_FAILED,
  FETCH_GATING_CONFIGURATIONS_FOR_MAPPING_REQUEST, FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_SUCCEEDED, FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_FAILED
} from "constants/actionTypes";

import _ from 'lodash';
import axios from 'axios';
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';
import { put, call, takeEvery, select } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import { createMixpanelEvent } from "actions/mixpanel";
import { MIXPANEL_GATING_CONFIGURED } from "constants/mixpanelEvents";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const GATING_CONFIGURATION_URL = `${apiUrl}/api/2.0/gating/configurations`;

/**
 * Create Gating Configuration
*/
export const createGatingConfiguration = createAction(CREATE_GATING_CONFIGURATION_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  };
})

/*
* Delete Asset Mappings Gatings
*/

export const deleteAssetGating = createAction(DELETE_ASSET_MAPPINGS_GATING_REQUEST, (storyboard, request) => {
  return {
    storyboard: storyboard,
    request: request
  }
})

const deleteAssetGatingSucceeded = createAction(DELETING_ASSET_MAPPINGS_GATING_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const deleteAssetGatingFailed = createAction(DELETING_ASSET_MAPPINGS_GATING_FAILED, (error) => {
  return {
    error: error
  }
});

function* deleteAssetMappingGatingSaga(action) {
  const {storyboard, request} = action.payload;

  const params = {
    storyboard: storyboard,
  };


  let url = buildUrl(GATING_CONFIGURATION_URL, {
    queryParams: params
  });

  const deleteAssetMappingGatingAPI = () => {
    return axios({
      method: 'DELETE',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try {
    const response = yield call(deleteAssetMappingGatingAPI);
    if (response) {
      yield put(deleteAssetGatingSucceeded(response));
    }
  } catch (error) {
    yield put(deleteAssetGatingFailed(error));
  }
}

/**
 * Update Gating Configuration
*/
export const updateGatingConfiguration = createAction(UPDATE_GATING_CONFIGURATION_REQUEST, (mappingId, id, request) => {
  return {
    mappingId: mappingId,
    id: id,
    request: request
  };
})

/**
 * Delete Gating Configuration
*/
export const deleteGatingConfiguration = createAction(DELETE_GATING_CONFIGURATION_REQUEST, (mappingId, id, gatingConfigId) => {
  return {
    mappingId: mappingId,
    id: id,
    gatingConfigId: gatingConfigId
  };
})

/*
* Create Gating Configuration For Mapping
*/
export const createGatingConfigurationForMapping = createAction(CREATE_GATING_CONFIGURATION_FOR_MAPPING_REQUEST, (storyboard, id, request) => {
  return {
    storyboard: storyboard,
    id: id,
    request: request
  };
})

const creatingGatingConfigurationForMappingSucceeded = createAction(CREATING_GATING_CONFIGURATION_FOR_MAPPING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const creatingGatingConfigurationForMappingFailed = createAction(CREATING_GATING_CONFIGURATION_FOR_MAPPING_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* createGatingConfigurationSaga(action) {
  const {storyboard, id, request} = action.payload;
  
  const params = {
    storyboard: storyboard,
  };

  let url = buildUrl(GATING_CONFIGURATION_URL, {
    path: `/create`,
    queryParams: params
  });

  const createGatingConfigurationAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try {
    const response = yield call(createGatingConfigurationAPI);
    if (response) {
      yield put(creatingGatingConfigurationForMappingSucceeded(id, response));
    }
  } catch (error) {
    yield put(creatingGatingConfigurationForMappingFailed(id, error));
  }
}

/**
 * Fetch gating configurations for mapping
*/
export const fetchGatingConfigurationsForMapping = createAction(FETCH_GATING_CONFIGURATIONS_FOR_MAPPING_REQUEST, (id, storyboard, mappingType) => {
  return {
    id: id,
    storyboard: storyboard,
    type: mappingType
  };
})

const fetchingGatingConfigurationsForMappingSucceeded = createAction(FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

const fetchingGatingConfigurationsForMappingFailed = createAction(FETCHING_GATING_CONFIGURATIONS_FOR_MAPPING_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* fetchGatingConfigurationsForMappingSaga(action) {
  const { id, storyboard, type } = action.payload;

  const params = {
    storyboard: storyboard,
    type: type
  };

  const url = buildUrl(GATING_CONFIGURATION_URL, {
    path: `/mapping/${id}`,
    queryParams: params
  });

  const fetchGatingConfigurationsAPI = () => {
    return axios({
      method: 'GET',
      url: url
    }).then(response => response.data);
  }

  try {
    const response = yield call(fetchGatingConfigurationsAPI);

    if (response) {
      yield put(fetchingGatingConfigurationsForMappingSucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchingGatingConfigurationsForMappingFailed(id, error));
  }
}


/**
 * Invalidate Gating Configuration
 */
export const invalidateGatingConfigurations = createAction(INVALIDATE_GATING_CONFIGURATIONS);

export default function* gatingConfigurationsSaga() {
  yield takeEvery(DELETE_ASSET_MAPPINGS_GATING_REQUEST, deleteAssetMappingGatingSaga);
  yield takeEvery(CREATE_GATING_CONFIGURATION_FOR_MAPPING_REQUEST, createGatingConfigurationSaga);
  yield takeEvery(FETCH_GATING_CONFIGURATIONS_FOR_MAPPING_REQUEST, fetchGatingConfigurationsForMappingSaga);
}